import APIUtils from '@spothero/utils/api';

const OversizedFeeAPI = {
    getOversizedFee({facilityId, vehicleProfileId, userId}) {
        return APIUtils.get('oversized-fee/', {
            facility_id: facilityId, // eslint-disable-line camelcase
            vehicle_profile_id: vehicleProfileId, // eslint-disable-line camelcase
            user_id: userId, // eslint-disable-line camelcase
        });
    },
};

export default OversizedFeeAPI;
